// directives/validation.js - rozšířená verze s možnostmi
export const vValidate = {
  mounted(el, binding) {
    const { rules, message, options = {} } = binding.value || {};
    
    // Výchozí možnosti
    const defaultOptions = {
      validateOnMount: true,    // Validovat hned při inicializaci
      validateOnInput: true,    // Validovat během psaní (pouze pokud už je pole invalid)
      validateOnBlur: true,     // Validovat při opuštění pole
      showValidState: true      // Zobrazit zelený border pro validní pole
    };
    
    const opts = { ...defaultOptions, ...options };
    
    // Přidej Bootstrap třídy
    el.classList.add('form-control');
    
    // Vytvoř feedback element
    const feedback = document.createElement('div');
    feedback.className = 'invalid-feedback';
    el.parentNode.appendChild(feedback);
    
    // Validační funkce
    const validate = (showValidState = opts.showValidState) => {
      let isValid = true;
      let errorMessage = '';
      
      if (rules) {
        if (rules.required && !el.value.trim()) {
          isValid = false;
          errorMessage = message?.required || 'Toto pole je povinné';
        } else if (rules.min !== undefined && el.value !== '' && parseFloat(el.value) < rules.min) {
          isValid = false;
          errorMessage = message?.min || `Minimální hodnota je ${rules.min}`;
        } else if (rules.max !== undefined && el.value !== '' && parseFloat(el.value) > rules.max) {
          isValid = false;
          errorMessage = message?.max || `Maximální hodnota je ${rules.max}`;
        } else if (rules.pattern && el.value !== '' && !rules.pattern.test(el.value)) {
          isValid = false;
          errorMessage = message?.pattern || 'Neplatný formát';
        }
      }
      
      // Aplikuj Bootstrap třídy
      if (isValid) {
        el.classList.remove('is-invalid');
        if (showValidState && el.value.trim() !== '') {
          el.classList.add('is-valid');
        } else {
          el.classList.remove('is-valid');
        }
        feedback.textContent = '';
      } else {
        el.classList.remove('is-valid');
        el.classList.add('is-invalid');
        feedback.textContent = errorMessage;
      }
      
      // Emituj custom event s výsledkem validace
      const validationEvent = new CustomEvent('validation', {
        detail: {
          isValid: isValid,
          errorMessage: errorMessage,
          fieldName: el.name || el.id || 'unknown',
          value: el.value
        },
        bubbles: true,
        cancelable: true
      });
      el.dispatchEvent(validationEvent);
      
      return isValid;
    };
    
    // Event listenery
    if (opts.validateOnBlur) {
      el.addEventListener('blur', () => validate());
    }
    
    if (opts.validateOnInput) {
      el.addEventListener('input', () => {
        // Validuj při psaní pouze pokud je pole už označeno jako invalid
        if (el.classList.contains('is-invalid')) {
          validate();
        }
      });
    }
    
    // Ulož validační funkci pro pozdější použití
    el._validate = validate;
    
    // VALIDACE HNED PŘI INICIALIZACI
    if (opts.validateOnMount) {
      setTimeout(() => {
        validate();
      }, 0);
    }
  },
  
  updated(el) {
    if (el._validate) {
      setTimeout(() => {
        el._validate();
      }, 0);
    }
  },
  
  unmounted(el) {
    const feedback = el.parentNode.querySelector('.invalid-feedback');
    if (feedback) {
      feedback.remove();
    }
  }
};